import React, { FC, useEffect, useState } from "react";
import { Row, Col, Layout, Button } from "antd";
import DispatchPanel from "./DispatchPanel/index";
import MapPanel from "./MapPanel/index";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
import DashboardModal from "./Dashboard/DashboardModal";
import DriverModal from "./Dashboard/DriverModal";
import { generateUUID } from "utils/appUtil";

Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const RideWrapper: FC<{ socket: ISocket }> = ({ socket }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [screens, setScreens] = useState<any>({
    form: true,
    map: true,
  });
  const [selected, setSelected] = useState<string>("map");
  const [componentUuids, setComponentUuid] = useState<any>({
    driver: generateUUID(),
    advance: generateUUID(),
    dispatch: generateUUID(),
    all: generateUUID(),
  });
  const params: any = {
    screens,
    setScreens,
  };
  const fixedColSize = 24;

  return (
    <Row
      className="main-layout"
      style={{
        transform: "scale(0.8)",
        transformOrigin: "0 0",
        width: "125vw",
        height: "100vh",
      }}
    >
      {screens.form && (
        <Col
          md={screens.map ? 7 : fixedColSize}
          xs={24}
          className={screens.active === "form" ? "active-screen" : ""}
          style={{
            height: "calc((100vh / 0.8) - 50px)",
            overflow: "scroll",
          }}
        >
          {screens.form && (
            <DispatchPanel
              socket={socket}
              params={params}
              fullScreen={true}
              scale={true}
            />
          )}
        </Col>
      )}
      {screens.map && (
        <Col
          span={17}
          style={{
            height: "calc((100vh / 0.8) - 70px)",
            overflow: "scroll",
          }}
        >
          <Row>
            <Col
              span={24}
              className={`ride-container ${
                screens.active === "map" ? "active-screen" : ""
              }`}
            >
              <div className="d-flex justify-content-start main-column map-content">
                <Button
                  onClick={() => {
                    setSelected("map");
                  }}
                  className={`beam-btn m-3 ${
                    selected === "map" ? "green-btn cover" : ""
                  }`}
                >
                  Map
                </Button>

                <Button
                  onClick={() => {
                    setSelected("advance");
                  }}
                  className={`beam-btn m-3 ${
                    selected === "advance" ? "green-btn cover" : ""
                  }`}
                >
                  Advance booking
                </Button>

                <Button
                  onClick={() => {
                    setSelected("dispatch");
                  }}
                  className={`beam-btn m-3 ${
                    selected === "dispatch" ? "green-btn cover" : ""
                  }`}
                >
                  Dispatching
                </Button>

                <Button
                  onClick={() => {
                    setSelected("driver");
                  }}
                  className={`beam-btn m-3 ${
                    selected === "driver" ? "green-btn cover" : ""
                  }`}
                >
                  Drivers
                </Button>
              </div>

              {selected === "map" && (
                <MapPanel socket={socket} params={params} />
              )}
              {selected === "driver" && (
                <div className="beam-modal analytics-summary-modal mr-4">
                  <Layout
                    className="main-layout exec-layout"
                    style={{ padding: 0 }}
                  >
                    <DriverModal
                      socket={socket}
                      componentUuid={componentUuids.driver}
                    />
                  </Layout>
                </div>
              )}
              {selected === "dispatch" && (
                <div className="beam-modal analytics-summary-modal mr-4">
                  <Layout
                    className="main-layout exec-layout"
                    style={{ padding: 0 }}
                  >
                    <DashboardModal
                      socket={socket}
                      filter={false}
                      selected={selected}
                      componentUuid={componentUuids.advance}
                    />
                  </Layout>
                </div>
              )}
              {selected === "advance" && (
                <div className="beam-modal analytics-summary-modal mr-4">
                  <Layout
                    className="main-layout exec-layout"
                    style={{ padding: 0 }}
                  >
                    <DashboardModal
                      socket={socket}
                      filter={false}
                      selected={selected}
                      componentUuid={componentUuids.advance}
                    />
                  </Layout>
                </div>
              )}
            </Col>
            <Col span={24}>
              <div className="beam-modal analytics-summary-modal mr-4">
                <Layout
                  className="main-layout exec-layout mt-3"
                  style={{ padding: 0 }}
                >
                  <DashboardModal
                    socket={socket}
                    filter={true}
                    componentUuid={componentUuids.all}
                  />
                </Layout>
              </div>
            </Col>
          </Row>
        </Col>
      )}
      <Autocomplete
        apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
        style={{ display: "none" }}
        options={{
          types: ["(regions)"],
          componentRestrictions: { country: ["us", "ca", "uk"] },
        }}
      />
    </Row>
  );
};

export default RideWrapper;
